export const schemaValidateCatalogRolesList = [
  {
    id: 1,
    field: "id",
    is_in_bdd:false,
    data_type: "id",
    type: "field",
    max_length: 80,
    component_new:"null",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-xs",
    readmore_limit_table: "null",
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-catalog-role",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 2,
    field: "name",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°\"\"“”,.()0-9/\\[\\]#->!+@$_&*:;?%<¿¡©®™~=^-|\\n ]+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-catalog-role",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 3,
    field: "description",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°\"\"“”,.()0-9/\\[\\]#->!+@$_&*:;?%<¿¡©®™~=^-|\\n ]+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-catalog-role",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 4,
    field: "abbreviation",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°\"\"“”,.()0-9/\\[\\]#->!+@$_&*:;?%<¿¡©®™~=^-|\\n ]+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-catalog-role",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 5,
    field: "deleted",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"null",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-catalog-role",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 6,
    field: "options",
    is_in_bdd:false,
    data_type: "buttons",
    type: "field",
    max_length: "null",
    component_new:"null",
    show_in_table: true,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: "null",
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-catalog-role",
    is_placeholder:false,
    occupation_new:6
  }
];